import { actionTypes } from './constants';
import { actionTypes as operationalParamActions } from '../../constants';
import { AnalyticsApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { createParamMeasurementAssetObjV2 } from '../../../../helpers';
import { getAssetTypeId } from 'helpers/assetAndPowertrainFilterHelper';
import { histoScatterDateFormat } from '../../OperationalParametersHeader/constants';
import moment from 'moment';

const scatterKpiAction = getApiActionCreator(actionTypes.GET_ASSET_SCATTER_KPIS_V2);
export const getScatterKPIsForAsset = (assetObj) => {
    return (dispatch) => {
        dispatch(scatterKpiAction(apiCallStatus.LOADING));
        AnalyticsApi.getScatterV2Config(assetObj?.id)
            .then((data) => {
                dispatch(scatterKpiAction(apiCallStatus.SUCCESS, data));
            })
            .catch((err) => {
                dispatch(scatterKpiAction(apiCallStatus.ERROR, null, err));
            });
    };
};

const scatterDataAction = getApiActionCreator(actionTypes.GET_SCATTER_V2);
export const getScatterForAsset = (from, to, assetObj, measurement) => {
    return (dispatch, getState) => {
        // Create parameter object for POST body content
        const param = createParamMeasurementAssetObjV2(measurement, assetObj, true);
        const originalAssetID = getState().powertrainAssetDetails?.selectedAsset?.id;
        from = moment(from).format(histoScatterDateFormat);
        to = moment(to).format(histoScatterDateFormat);
        dispatch(scatterDataAction(apiCallStatus.LOADING));

        AnalyticsApi.getScatterV2Data(param, from, to)
            .then((data) => {
                const assetID = getState().powertrainAssetDetails?.selectedAsset?.id;

                if (originalAssetID === assetID) {
                    dispatch(scatterDataAction(apiCallStatus.SUCCESS, data));
                }
            })
            .catch((err) => {
                dispatch(scatterDataAction(apiCallStatus.ERROR, null, err));
            });
    };
};

export const setSelectedDates = (from, to) => {
    return (dispatch) => {
        dispatch({ type: operationalParamActions.SET_DATE_SELECTION, dateSelection: { from, to } });
    };
};


export const setSelectedKpi = (scatterSelectedKpi) => {
    return (dispatch, getState) => {
        const asset = getState()?.powertrainAssetDetails?.selectedAsset;
        dispatch({
            type: actionTypes.SET_SCATTER_KPI_V2,
            scatterSelectedKpi: {
                ...scatterSelectedKpi,
                assetTypeID: getAssetTypeId(asset?.assetType)
            }
        });
    };
};

const removeSelectedKpiLegendAction = (signalIndex) => {
    return {
        type: actionTypes.REMOVE_TREND_KPI_SELECTION_LEGEND_SCATTER_V2,
        signalIndex
    };
};

// Action Creators
export const removeSelectedKpiLegend = (signalIndex) => {
    return (dispatch) => {
        dispatch(removeSelectedKpiLegendAction(signalIndex));
    };
};
